module.exports = __webpack_public_path__ + "static/img/top3_i1_nav.437a70fc.png";